function startTimeout(executionId, ms) {
    setTimeout(() => {
        console.log(`Request timed out, execution ID was: ${executionId}`);
    }, ms);
}

export { startTimeout };
//# sourceMappingURL=executions.js.map
